import { doLogin } from '@/api/login'
import { getToken, setToken, removeToken, getUser, setUser } from '@/utils/auth'
import { resetRouter } from '@/router'

const state = {
    token: getToken(),
    name: '',
    avatar: '',
    userInfo: getUser() ? JSON.parse(getUser()) : {},
    roles: []
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_ID: (state, id) => {
        state.id = id
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar || 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif'
    }
}

const actions = {
    // user login
    login ({ commit }, userInfo) {
        const { username, password, type, code } = userInfo
        return new Promise((resolve, reject) => {
            doLogin({ username: username.trim(), password: password, type: type, code: code }).then(response => {
                const { data } = response
                console.log(data)
                data.password = password
                commit('SET_TOKEN', data.token)
                commit('SET_NAME', data.name)
                commit('SET_AVATAR', data.icon)
                commit('SET_ID', data.userId)
                setToken(data.token)
                setUser(JSON.stringify(data))
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // user logout
    logout ({ commit, state }) {
        return new Promise((resolve, reject) => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resetRouter()
            resolve()
        })
    },

    // remove token
    resetToken ({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            removeToken()
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js